import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { uploadNotificationImageApi } from "../api/NotificationsApi";

const initialState = {
  fileUploadRespone: '',
  uploading: false,
  openToggler: false,
};

export const uploadNotificationImage = createAsyncThunk(
  "adminNotification/uploadNotificationImage",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadNotificationImageApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const adminNotifictionSlice = createSlice({
  name: "adminNotification",
  initialState,
  reducers: {
    setToggler: (state, action) => {
      state.openToggler = action.payload
    },
  },
  extraReducers: (builder) => {

    //file upload
    builder.addCase(uploadNotificationImage.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(uploadNotificationImage.fulfilled, (state, action) => {
        console.log('File response slice', action.payload)
      state.fileUploadRespone = action.payload.response;
      state.uploading = false;
    });
    builder.addCase(uploadNotificationImage.rejected, (state) => {
      state.uploading = false;
    });

  },
});

export const { setToggler } = adminNotifictionSlice.actions;
export default adminNotifictionSlice.reducer;
